<cb-top-bar (logout)="logout()" (uploadPhoto)="openImageUploader($event)"
            [background]="background$ | async" [image]="image$ | async"
            [isAdmin]="isAdmin$ | async" [isGuideOrAdmin]="isGuideOrAdmin$ | async"
            [isGuide]="isGuide$ | async" [isStudent]="isStudent$ | async"
            [isViewSkillsStackAccess]="isViewSkillsStackAccess$ | async">
  <notification-popup *ngIf="isAdmin$ | async"></notification-popup>
</cb-top-bar>
